import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeedream = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.424 15.1297C6.567 12.0047 7.994 10.1297 8.548 9.51367C5.832 11.2287 4.028 14.2287 3.25 16.4377V17.3707C3.249 19.9267 5.519 21.9997 8.324 21.9997C8.948 21.9997 9.568 21.8947 10.157 21.6867C10.452 21.5867 10.741 21.4807 11.023 21.3717C11.7648 20.6365 12.3949 19.7966 12.893 18.8787C8.828 20.9047 6.247 18.9387 6.423 15.1287L6.424 15.1297Z",
			fill: "#1E37FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8074 10.5703C19.7974 9.81833 17.3834 8.56633 14.6434 8.23633C14.8894 11.3963 14.7214 15.5413 12.8934 18.8803C12.3957 19.7985 11.7656 20.6385 11.0234 21.3733C14.1604 20.1673 16.6454 18.4933 18.1874 17.0243C20.5374 14.7883 20.9814 12.7093 20.9874 11.4743C20.9895 11.1642 20.9282 10.857 20.8074 10.5713V10.5703Z",
			fill: "#37E1BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.92 3.556C12.795 2.583 11.372 2 9.824 2C8.276 2 6.902 2.564 5.787 3.506C4.325 4.742 3.355 6.63 3.25 8.77V16.437C4.027 14.229 5.83 11.229 8.547 9.515C8.96383 9.25008 9.40123 9.01901 9.855 8.824C11.425 8.157 13.087 8.047 14.643 8.236C14.523 6.65923 14.2806 5.09418 13.918 3.555L13.92 3.556Z",
			fill: "#A569FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4199 6.13464L15.5199 5.22364C15.3519 5.04564 15.1899 4.87364 15.0329 4.70464L13.9219 3.55664C14.0469 4.06864 14.4619 5.87864 14.6459 8.23664C17.3859 8.56664 19.7999 9.81864 20.8089 10.5706C19.7209 9.50864 17.9119 7.66464 16.4199 6.13464Z",
			fill: "#1E37FC"
		})
	]
});
const ForwardRef = forwardRef(SvgSeedream);
export default ForwardRef;
